export const BASE_URL = process.env.VUE_APP_API_URL || "http://localhost:4400";
